export enum PaymentSource {
  Direct_Debit = '001',
  Credit_Card = '002',
  Auto_Debit = '003',
  Standing_Instruction = '004',
  Salary_Deduction = '005',
  BPA = '006',
  Inter_Bank = '007',
}
